export default __webpack_public_path__ + "static/media/mysteryBetLogo.17d2176d.png";